import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Tooltip, Button } from '@trevor/ui-components';
import sidebar from '@/css/module/sidebar.css';
import flex from '@/css/module/flex.css';
import { getQueryBuilderSteps } from '@/store-selectors';
import { useAppDispatch } from '@/store/hooks';
import { setLastVisitedURL } from '@/features/query-builder/queryBuilderSlice';
import { START_NEW_QUERY } from '@/actions/constants';
import { reset, UndoRedo } from '@/features/query-builder-steps-undo-redo';

export const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const numberOfSteps = useSelector(getQueryBuilderSteps).length;

  const handleStartNewQuery = () => {
    dispatch(setLastVisitedURL(null));
    dispatch({ type: START_NEW_QUERY });
    dispatch(reset());
    navigate('.');
  };

  return (
    <div className={sidebar.title} data-quickfix-2-remove-on-refactoring>
      <div className={sidebar.titleControl}>
        <Button
          data-tooltip-id="startAgain"
          variant="secondary"
          onClick={handleStartNewQuery}
        >
          Start new query
        </Button>

        <Tooltip id="startAgain" place="bottom">
          Start again
        </Tooltip>
      </div>
      <UndoRedo />
      <div className={sidebar.titleInner}>
        <div className={`${flex.column} margin-right-5`}>
          <div className={flex.alignItemsCenter}>
            <h4
              className="panel-title sidebar-header margin-right-5"
              style={{ marginTop: '0px' }}
            >
              {`${numberOfSteps} QUERY STEP${numberOfSteps > 1 ? 'S' : ''}`}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};
